export const REACT_APP_URL_SSO = process.env.REACT_APP_URL_SSO;
export const REACT_APP_SSO_API = process.env.REACT_APP_SSO_API;
export const REACT_APP_CUSTOMER_API = process.env.REACT_APP_CUSTOMER_API;
export const REACT_APP_UPLOAD_FILE = process.env.REACT_APP_UPLOAD_FILE;
export const REACT_APP_PRICE_API = process.env.REACT_APP_PRICE_API;